import React from "react";
import * as Icons from "./Icons";

export type SocialIconNames = "Facebook" | "Twitter" | "Instagram";
export type SocialIconColors = "black" | "white" | "color";

export interface SocialIconProps {
  /**
   * Name of the social icon
   */
  icon: SocialIconNames;

  /**
   * Which variant to use
   */
  color: SocialIconColors;
}

// Type for the svg icon wrappers in "./icons"
export type IconProps = Pick<SocialIconProps, "color">

export interface GetColorProps extends Pick<SocialIconProps, "color"> {
  /**
   * Fill color when "color" variant is set
   */
  colorFill: string;
}

/**
 *
 * Set the color from the SocialIcon "color" prop
 */
export const getSocialIconColor = (x: GetColorProps) => {
  let fill: string;

  switch (x.color) {
    case "black":
      fill = "#000"
      break;
    case "white":
      fill = "#fff"
      break;
    default:
      fill = x.colorFill
  }

  return fill;
};

/**
 * Social Icon
 *
 * @status development
 */
export const SocialIcon: React.FC<SocialIconProps> = (props) => {
  const {
    icon,
    ...rest
  } = props;

  if (!icon) {
    return null;
  }

  const Icon = Icons[icon];

  return <Icon {...rest} />
}
